// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '@lyh/jsbridge' //要先移除之前的jsbridge
const isInIframe = window !== window.top;
import '../static/js/config'
import '../static/js/compression'
import Vue from 'vue'
import VueResource from 'vue-resource'
// import nativeAnalysis from '@lyh/native-analysis'
// import TimeMe from 'timeme.js'
import Exposure from './util/exposure'
import Click from './util/click'
import getToolsInfoCompleteState, { getPrefectToastConfig, getTNMDetailInfoCompleteState, getUserPlan } from './util/tools'
//fix 低版本浏览器不支持Promise的finally方法
import promiseFinally from 'promise.prototype.finally'
promiseFinally.shim()

import * as Sentry from '@sentry/vue'
/**
 * 0.promise 没有 catch
 * 1.视频直播没有流
 * 2.调用原生方法没有回调（新版本app已修复）
 * >= 3.线上过滤请求异常错误不上报sentry
 */
let ignoreErrors = [
  'Non-Error promise rejection captured with keys: body, bodyText, headers, ok, status',
  'Uncaught ReferenceError: o is not defined',
  'responseCallback is not a function',
  'Network Error',
  'Request aborted',
  'Request failed with status code 404',
  'Request failed with status code 502',
  'Request failed with status code 400',
  'timeout exceeded',
]
Sentry.init({
  Vue,
  dsn: 'https://ca6a175ebc0945d597f04199213dcae6@sentry.liangyihui.net/19',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  tracePropagationTargets: ['localhost', '127.0.0.1', /192\.168\.*/, /10\.170\.*/, /^\//],
  environment: process.env.MODE === 'prod' ? 'production' : process.env.MODE === 'pre' ? 'preview' : 'development',
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
  logErrors: true,
  trackComponents: true,
  replaysOnErrorSampleRate: 0.1,
  // hooks: ['activate', 'create', 'destroy', 'mount', 'update'],
  // debug: true,
  release: 'lyhdoctor@' + process.env.SENTRY_RELEASE,
  // 过滤这些错误 不上报
  ignoreErrors,
})
import JSBridge from '@lyh/jsbridge'
import JSLogin from '@lyh/jslogin'
//use <link rel="stylesheet" href="//unpkg.liangyihui.net/vant@2.12.54/lib/index.css" /> instead of
// import 'vant/lib/index.css'
import { Dialog } from 'vant'

import BtnOpenApp from '@lyh/open-app'
import EmptyPage from '@lyh/empty-page'
import '@lyh/empty-page/dist/css/empty-page.css'

Vue.use(JSBridge)
Vue.use(JSLogin)
Vue.use(BtnOpenApp)
Vue.use(EmptyPage)
// Vue.prototype.TimeMe = TimeMe;
// Vue.prototype.nativeAnalysis = nativeAnalysis

// import VueRouter from 'vue-router'
var _ = require('lodash')
Vue.prototype._ = _
// Vue.use(VueRouter)
Vue.use(VueResource)
import MintUi from 'mint-ui'

Vue.use(MintUi)

import Vtap from 'v-tap'

Vue.use(Vtap)

import VueLazyload from 'vue-lazyload'

Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-launch-app']

Vue.use(VueLazyload, {
  filter: {
    webp({ src }) {
      const isCDN = /qiniucdn.com/
      if (isCDN.test(src)) {
        if (src.indexOf('imageMogr2') > -1) {
        } else {
          // src += '?imageView2/2/format/webp?imageslim'
          src += '?imageslim'
        }
      }
      return src
    },
  },
})

import Lai from './vue-lai'
import TaskCenter from './mixins/task-center'
import Stay from './mixins/stay'

Vue.use(Lai)
Vue.use(TaskCenter)
Vue.use(Stay)

import store from './store'

import router from './route'

// axios
import '@/ajax'

// var routes = Router.routes;

import lyhHeader from './components/lyhHeader.vue'
import SideBar from './components/SideBar.vue'
import GoTop from './components/GoTop.vue'
import Loading from './components/Loading.vue'
import TaskCountDown from './MyTask/Components/TaskCountDown.vue'
import MiniprogramToast from './components/MiniprogramToast.vue'
import ToolsPrefectToast from './components/ToolsPrefectToast.vue'

// var router = new VueRouter({
//     routes
// })

//引入专场动效
// import { goPC } from './pcRedirect/index'
import { communicate } from './utils'
import { api } from './apic'

import { MessageBox, Toast } from 'mint-ui'
//统计时长
// import {initWs} from '@lyh/duration-statistics'

// router.beforeEach((to, from, next) => {
//     // console.log(routes);
//     goPC(to)
//     var match = routes.filter(function(e) {
//         //alert(to.path);
//         // console.log('path=>'+to.path+'[name]=>'+to.name+'[e.name]=>'+e.name);
//         if (e.children && e.children.length) {
//             let ischildren = false;
//             for (let i = 0; i < e.children.length; i++) {
//                 let ch = e.children[i];
//                 if (ch.name == to.name) {
//                     ischildren = true;
//                 }
//             }
//             if (ischildren) {
//                 return true;
//             }
//         }
//         return e.name == to.name;
//     });

//     globalstore.commit('CLOSE_POPUP');

//     // 设置标题
//     if (match[0].children && match[0].children.length) {
//         let mt = match[0].children.filter(function(e) {
//             return e.name == to.name;
//         });
//         // console.log(mt);
//         document.title = mt[0].title;
//     } else {
//         document.title = match[0].title;
//     }

//     next()
// })

// router.afterEach(route => {
//     // ...
//     if (route.name !== 'Index') {
//         setTimeout(function() {
//             window.scrollTo(0, 0);
//         }, 300);
//     }

// })
import sensors from 'sa-sdk-javascript'
// https://manual.sensorsdata.cn/sa/latest/zh_cn/tech_sdk_client_web_api-7538088.html#id-%E5%9F%BA%E7%A1%80API%E4%BB%8B%E7%BB%8D%EF%BC%88Web%EF%BC%89-SDK%E5%88%9D%E5%A7%8B%E5%8C%96%E5%8F%82%E6%95%B0
/*

sensors.init({
  server_url: window.Global_Sensors_Server,
  is_track_single_page: function () {
    return false
  }, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件, web页面浏览事件采集关闭自动模式
  // 在 src/route/index.js 后置路由守卫中手动触发页面浏览事件采集 详细配置参考文档 https://manual.sensorsdata.cn/sa/latest/zh_cn/web-109576411.html#id-高级功能（Web）-手动模式
  use_client_time: true,
  send_type: 'ajax',
  app_js_bridge: true, //小程序的h5页面，埋点数据自己处理
  show_log: true,
  batch_send: window.ISAPP, //false表示实时发送网络请求
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
    //通过 get_vtrack_config 配置是否开启可视化支持自定义属性和任意层级 div 标签功能，默认关闭
    get_vtrack_config: true,
  },
  max_string_length: 2000, //解决默认500导致$url 截断问题
})
*/

// 区分平台
var platformType = ''
if (window.ISAPP) {
  // 先判断是否在app中
  if (window.browser.versions.ios) {
    platformType = 'iOS'
  } else if (window.browser.versions.android) {
    platformType = 'Android'
  }
} else if (window.ISWXMINI) {
  // 必须先判断是否在小程序里，再判断是否在微信里
  platformType = '小程序'
} else if (window.ISWX) {
  platformType = 'wx'
} else if (window.ISPC) {
  platformType = 'pc'
} else if (window.ISMOBILE) {
  platformType = 'mb'
} // 如果神策统计到空字符串情况通过上报的ua进行排查修正
// sensorsRegisterPage(platformType)
window.platformType = platformType
//在神策SDK isReady 时，获取AnonymousID（匿名id）存储到本地缓存，方便后续调用查询;https://liangyihui.feishu.cn/wiki/wikcnZyfid2X4Oy3ad1T85d9VFf

/*
sensors.quick('isReady', function () {
  if (sensors.quick('getAnonymousID')) {
    localStorage.setItem('AnonymousID', sensors.quick('getAnonymousID'))
    Sentry.setUser(sensors.quick('getAnonymousID'))
  }
})
*/

/**
 * 全埋点触发后置 在route.beforeEach 中触发 防止document.title 取不到值
 */

// sensors.quick('autoTrack')

window.page_leave_custom_props = {}
window.pageLeaveIsCollect = true
// 页面浏览时长
/*
sensors.use('PageLeave', {
  custom_props: window.page_leave_custom_props,
  heartbeat_interval_time: 2,
  isCollectUrl: function (url) {
    // url 为要采集页面浏览时长的页面地址。
    return window.pageLeaveIsCollect //是否发送神策页面离开埋点 ($webPageLeave)
    // return true; // 采集
    // return false; // 不采集
  },
})
*/

Vue.prototype.$sensors = sensors //挂载sensors
window.$sensors = sensors

/**
 * 神策初始化相关 （目的：延迟初始化，应对本地缓存数据不存在的情况下，用户登录后，加载的页面携带的事件中的事件属性$is_login_id为false）
 * PS: 本方法只是把之前的神策相关设置集中到一起，然后延迟设置神策SDK相关配置; 对于app，还是在new Vue之前初始化，保持原样
 */
const initSensors = () => {
  // console.log('神策初始化-----------1')
  sensors.init({
    server_url: window.Global_Sensors_Server,
    is_track_single_page: function () {
      return false
    }, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件, web页面浏览事件采集关闭自动模式
    // 在 src/route/index.js 后置路由守卫中手动触发页面浏览事件采集 详细配置参考文档 https://manual.sensorsdata.cn/sa/latest/zh_cn/web-109576411.html#id-高级功能（Web）-手动模式
    use_client_time: true,
    send_type: 'ajax',
    app_js_bridge: true, //小程序的h5页面，埋点数据自己处理
    show_log: false,
    batch_send: window.ISAPP, //false表示实时发送网络请求
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'not_collect',
      //通过 get_vtrack_config 配置是否开启可视化支持自定义属性和任意层级 div 标签功能，默认关闭
      get_vtrack_config: true,
    },
    max_string_length: 2000, //解决默认500导致$url 截断问题
  })
  // console.log('神策初始化-----------2')

  // 注册公共属性（必须在SDK初始化后调用）
  sensorsRegisterPage(window.platformType)

  //获取预置属性
  sensors.quick('isReady', function () {
    if (sensors.quick('getAnonymousID')) {
      localStorage.setItem('AnonymousID', sensors.quick('getAnonymousID'))
      Sentry.setUser(sensors.quick('getAnonymousID'))
    }
  })

  sensors.use('PageLeave', {
    custom_props: window.page_leave_custom_props,
    heartbeat_interval_time: 2,
    isCollectUrl: function (url) {
      // url 为要采集页面浏览时长的页面地址。
      return window.pageLeaveIsCollect //是否发送神策页面离开埋点 ($webPageLeave)
      // return true; // 采集
      // return false; // 不采集
    },
  })
}
/**
 * 获取用户tag 神策数据埋点来源
 * ps: 只是把new Vue中的getDoctorTag方法提到这里的，把网络请求改成同步的
 */
async function getDoctorTag() {
  if (head.auth) {
    let postData = {
      head,
      tagGroupId: 2, //分组ID 1: 行为属性  2: 基础属性
    }
    let postUrl = Global_apiserver + 'api/tag/getDoctorTag'
    let response = await Vue.prototype.$axios.post(postUrl, postData)
    let res = response.body
    // console.log('获取tag结果------',res)
    let tags = {}
    if (res.data && res.data.length) {
      res.data.forEach((item) => {
        tags[item.tagCode] = item.valueDesc
      })
      tags['userId'] = res.data[0].userId
      console.log(tags, 'tag1')
    }
    var tagsKeys = Object.keys(tags)
    if (tagsKeys.length) {
      sensors.setProfile(tags)
    }
  }
}

/**
 * 在小程序未登录的情况下，为了小程序和h5打通，把小程序的openid传递过来给h5作为匿名ID （小程序也是使用openid作为匿名ID的）
 */
function setMiniProgramAnonymousId() {
  if (window.ISWXMINI && !localStorage.getItem('auth') && !localStorage.getItem('hasSetSensorDistinctId') && location.href) {
    let sensorDistinctId = 'sensorDistinctId'
    let miniProgramDistinctId = getSearchParams(location.href, sensorDistinctId)
    if (miniProgramDistinctId) {
      //小程序中加载h5的话，未登录情况下，需要将小程序的distinctid设置给h5（一般都是小程序的openid），方便小程序和h5打通
      sensors.identify(miniProgramDistinctId, true)
      localStorage.setItem('hasSetSensorDistinctId', 1)
      location.replace(deleteUrlQuerys(location.href, [sensorDistinctId])) //重新加载url,防止url被分享，导致sensorDistinctId串给其他用户
    }
  }
}

let silenceLoginData = {}

/**
 * 适用于非APP的web配置vue挂载
 *
 * 调整成本方法的原因：
 * 之前的new Vue之后挂载到APP(#app)和created中的静默登录两者是异步的。 即main.js中的静默登录可能还没执行完，具体的vue页面已经走完created了的。
 * 这样就会导致全埋点（如$pageview等）先于静默登录中的神策login先执行，导致全埋点的事件属性$is_login_id为false。
 *
 * 复现的场景：清除本地缓存，然后冷启动页面
 *
 * 改成本方法后：
 * 若是本地有auth，必须先静默登录拿到auth信息后，再初始化神策SDK，后调用神策的login方法进行用户信息关联，再进行APP挂载。 这样就解决了上面的异步问题。
 */
async function setNotAppInit() {
  let auth = await JSLogin.tryGetAuth()
  // console.log('非APP 初始化-----------------静默登录---tryGetAuth:', auth)
  if (auth && auth.length) {
    if (window.ISWXMINI) {
      // 小程序
      // 有时候在退出微信，重新登录小程序后，小程序中h5的本地缓存不会被清空，
      // 导致auth等信息还是可以从缓存中拿到，但是这个auth其实可能已经失效了（如用户被删除，之前的auth是无效的，但是后端那边对这个失效的auth仍给了个10分钟的有效时间，导致多数接口都不会报错的）
      // 故每次加载h5页面，都从小程序拿auth的
      //
      // 小程序能保证分享删除auth，且加载的页面链接的时候用的是小程序项目中的getWebUrlAuthQuery，getWebUrlAuthQuery会修改把自己的auth设置给h5的，因此小程序中不用担心auth被篡改的情况（即：A用户分享给B用户，B用户打开后，结果设置auth给h5的时候用的是A用户的auth），
      localStorage.setItem('auth', auth)
      localStorage.setItem('auth2', 'liangyihui')
    } else {
      const localAuth = localStorage.getItem('auth')
      if (!localAuth) {
        //本地有auth不设置，是以防遇到分享串auth的情况（分享链接中带auth）
        localStorage.setItem('auth', auth)
        localStorage.setItem('auth2', 'liangyihui')
        // window.location.reload()
        // return
      }
    }
  }

  auth = localStorage.getItem('auth')
  let auth2 = localStorage.getItem('auth2') || 'liangyihui'
  if (auth) {
    // console.log('非APP 初始化-----------------静默登录---1')
    // 静默登录
    const apiurl = api.silencelogin.apiurl
    const postData = api.silencelogin.postData
    head.auth = auth
    head.auth2 = auth2
    postData.head = head

    let userId = '' // 用户ID
    try {
      silenceLoginData = await Vue.prototype.$axios.post(apiurl, postData)
      if (silenceLoginData) {
        if (silenceLoginData.body.responseStatus.ack === 0) {
          // 登录成功
          userId = silenceLoginData.body.userId
          // 更新auth
          auth = silenceLoginData.body.auth
          auth2 = silenceLoginData.body.auth2
          await store.dispatch('saveUser', {
            auth,
            auth2,
          })
        } else if (silenceLoginData.body.responseStatus.ack === 1) {
          // auth过期了
          localStorage.removeItem('auth')
          localStorage.removeItem('auth2')
          localStorage.removeItem('LYH_JSLOGIN_AUTH_KEY')
          localStorage.removeItem('hasSetSensorDistinctId')
          window.location.reload()
          return
        }
      }
    } catch (error) {
      console.log('静默登录失败：', error)
    }

    //sensors.logout()后面需要紧跟着sensors.login，原因：
    //logout后会导致事件属性$is_login_id变为false（神策本地缓存的$is_login_id会变为false）。
    //若是sensors.logout后，需要等会儿才调用sensors.login。那么在sensors.logout到sensors.login之间的这段时间，埋点的事件的事件属性$is_login_id就是false了的。
    //遇到的场景：
    //分享出去的页面冷启动（即第一次加载h5项目），$pageview事件的$is_login_id为false
    sensors.logout() //神策的api可以先于神策初始化调用的，先退出登录是应对之前是登录的情况，后如删除账号后，再次走本项目时，需要先去除之前的神策登录信息
    if (userId) {
      sensors.login(userId) //静默登录成功过后调用神策login方法
      // console.log('走到silencelogin-----------------1--',userId)
      Sentry.setUser({ id: userId })
    } else {
      //小程序设置匿名ID（只有未登录情况下才设置）
      setMiniProgramAnonymousId()
    }
    //初始化神策SDK
    initSensors()

    await getDoctorTag()

    newvue()
  } else {
    sensors.logout()
    //小程序设置匿名ID（只有未登录情况下才设置）
    setMiniProgramAnonymousId()
    //初始化神策SDK
    initSensors()

    newvue()
  }
}

// import tim from './components/chat/tim'
// import TIM from 'tim-js-sdk'
// import { initTimListener } from './components/chat/timChat'
import './util/shareLink'

// Vue.prototype.$tim = tim
// Vue.prototype.$TIM = TIM

// 检测是否在 azPreface iframe 中
const isAzPrefaceIframe = window.location.href.indexOf('isAzPreFace=true') > -1;

if (is_app()) {
  //在app内 调用原生初始化
console.log(`App环境初始化:${is_app()},${isInIframe},${location.href}`)
  // app中的h5页面，仍和以前一样，一开始就初始化的，不用进行任何判断，只是初始化稍微晚了一点点，这点时间可以忽略
  initSensors()
console.log(`initSensors:${is_app()},${isInIframe},${location.href}`)
  
  // ===== azPreface iframe 隔离：跳过 JSBridge 初始化 =====
  if (isAzPrefaceIframe) {
    console.log('[azPreface] 检测到在 iframe 中，跳过 JSBridge 初始化');
    // 让 wsharep 指向父窗口
    // if (window.parent && window.parent.wsharep && window.parent !== window) {
    //   console.log('[azPreface] 将 wsharep 指向父页面');
    //   window.wsharep = window.parent.wsharep;
    // }
    // 直接初始化 Vue，不调用 JSBridge
    newvue();
  } else {
    //alert('INAPP');.0
  setupWebViewJavascriptBridge(function(bridge) {
    console.log('JSBridge初始化成功', bridge);
    console.log(`setupWebViewJavascriptBridge:${is_app()},${isInIframe},${location.href}`)
    global_register()
    shareUrl_append()
    nativefun('getAuth2', {}, function (responseData) {
      var obj = JSON.parse(responseData)
      auth1 = obj.auth1
      auth2 = obj.auth2
      version = obj.version
      head.auth = auth1
      head.auth2 = auth2
      head.cver = version
      head.runPlatform = is_app() ? 'APP' : (is_wxmini() ? 'MINI' : 'H5'),
      head.extensions = obj.extensions
      //mdjson.head.cver = version
      //mdjson.head.auth = auth1
      //console.log('I8')
      //console.log(head.auth)
      nativefun('getHead1', {}, function (responseData) {
        //console.log('I1')
        var obj = JSON.parse(responseData)
        head = obj
        head.runPlatform = is_app() ? 'APP' : (is_wxmini() ? 'MINI' : 'H5'),
        mdjson.head = head
        //$.alert(JSON.stringify(head));
      })
      newvue()
    })
  })
  }
  
} else {
  console.log('NOTAPP')

  // var testauth1 = "JgaYHRoK7KbBwYpLm8jO2zdM0EskxiLBS5sikyxCjcs=";
  // var testauth2 = "bRFfBD2VUig==";
  var testauth1 = ''
  var testauth2 = ''
  auth1 = testauth1
  auth2 = testauth2
  head.auth = testauth1
  head.auth2 = testauth2
  head.cver = '8.3'
  head.runPlatform = is_app() ? 'APP' : (is_wxmini() ? 'MINI' : 'H5'),
  // newvue()

  setNotAppInit()
}

function newvue() {
  //alert(1);
  eventHub = new Vue()

  window.globalstore = store

  new Vue({
    el: '#app',
    mixins: [Lai.mixin, TaskCenter.mixin, Stay.mixin],
    template: `<div class="wx-app" @mousemove="handleStayMouseMove" @touchmove="handleStayTouchMove">
                  <div v-if="platform === 'wx'" class="wx-container">
                    <lyhHeader v-show="!isinminiprogram && notIframe"></lyhHeader>
                    <SideBar v-show="!isinminiprogram"></SideBar>
                    <TaskCountDown  v-model="taskStayProps.show" :visible="taskStayProps.visible" :time="taskStayProps.time" :auto-start="taskStayProps.autoStart" @finish="finishStayTask" ></TaskCountDown>
                    <GoTop></GoTop>
                    <Loading></Loading>
                    <MiniprogramToast v-show="miniGuide" :guide="miniGuide" @closeToast="closeMini" :current-route="$route"></MiniprogramToast>
                    <ToolsPrefectToast v-show="prefectShow" :userPlan="userPlan" :isPrefect="prefectNum" :prefectType="prefectType" :belong_page="belong_page" :page_source="page_source"></ToolsPrefectToast>
                    <transition :name="transitionName" >
                      <keep-alive include="dgDoctorList,ClinicalRecruitment,Index,AllHospital,AllOffice,UploadSourceData,Vote2021,Vote2022,Vote2025,ClinicalGuideSelect,CreditMallOrderList,urinaryTeamHome,urologicalTumors,AILiterature,AILiteratureSearch,AILiteratureCollect,AILiteratureList,aiDetail,TnmAiPatient,TnmDetail,FormulaIndex,DoctorToolsIndex,FormulaTool">
                        <router-view class="child-view" v-bind:class="{ noMarginTop: platform == 'app' || isinminiprogram || !notIframe}" :key="$route.fullPath"></router-view>
                      </keep-alive>
                    </transition>
                  </div>
                  <div v-else>
                    <TaskCountDown  v-model="taskStayProps.show" :visible="taskStayProps.visible" :time="taskStayProps.time" :auto-start="taskStayProps.autoStart" @finish="finishStayTask" ></TaskCountDown>
                    <ToolsPrefectToast v-show="prefectShow" :userPlan="userPlan" :isPrefect="prefectNum" :prefectType="prefectType" :belong_page="belong_page" :page_source="page_source"></ToolsPrefectToast>
                    <GoTop></GoTop>
                    <transition>
                      <keep-alive include="dgDoctorList,ClinicalRecruitment,AllHospital,AllOffice,UploadSourceData,Vote2021,Vote2022,Vote2025,ClinicalGuideSelect,CreditMallOrderList,urinaryTeamHome,urologicalTumors,urology2023,urologyPage,aiDetail,TnmAiPatient,TnmDetail,FormulaIndex,DoctorToolsIndex,FormulaTool">
                        <router-view :key="$route.fullPath"></router-view>
                      </keep-alive>
                    </transition>
                  </div>
        </div>`,
    data: {
      rootvar: {},
      testvar: 'ok',
      transitionName: 'slide-left',

      isActive: false,
      chatunreader: -1,

      isinminiprogram: false,
      notIframe: true,
      drugsLoginConfig: null,
      userPlan: null,
      // drugsRouteName: [
      //   'drugsHome',
      //   'drugsHomeYear',
      //   'drugsResearch',
      //   'drugsResearchYear',
      //   'drugsByDisease',
      //   'drugsByDiseaseYear',
      //   'drugsDetail',
      //   'drugsDetail',
      //   'drugsDetailYear',
      //   'previewPDF',
      //   'TnmList',
      //   'TnmDetail',
      //   'TnmAiDetail',
      //   'TnmAiBasis',
      //   'TnmAiHistory',
      //   'TnmAdviceDetail',
      //   'CpgList',
      //   'CpgDetail',
      //   'CpgUpdate',
      //   'TrjList',
      //   'TrjDetail',
      //   'TrjUpdate',
      //   'TrjSearch',
      //   'DaHome',
      //   'DaHomeYear',
      //   'DaDetail',
      //   'DaDetailYear',
      //   'DaSearch',
      //   'DaSearchYear',
      //   'DaDisease',
      //   'DaDiseaseYear',
      //   'DaPreview',
      //   'DaPreviewYear',
      //   'CmmHome',
      //   'CmmHomeSub',
      //   'CmmDetail',
      //   'CmmCollection',
      //   'FormulaBsa',
      //   'FormulaCarbo',
      //   'FormulaCcr',
      //   'FormulaBmi',
      //   'DoctorToolsIndex',
      //   'BMICompute',
      //   '2025CmmHome',
      //   '2025CmmHomeSub',
      //   '2025CmmDetail',
      //   '2025CmmCollection',
      //   'BED',
      //   'SNSF',
      //   'psStore',
      //   'zpsStore',
      //   'kpsStore',
      //   'painGrading',
      //   'TnmAllRecommendGuideList'
      // ],
      trackParams: {},
      miniGuide: false,

      // 工具类完善信息相关
      prefectShow: false,
      prefectNum: 0,
      prefectType: 0,
      belong_page: '',
      page_source: '',
    },
    store: globalstore,
    mounted() {
      let that = this
      setInterval(function () {
        let rname = that.$route.name
        let id = that.$route.params.id
        //alert(rname);
        if (rname == 'doc') {
          //console.log(id),

          laiyuanmd(id)
        }
      }, 4321)

      /*this.$tryGetAuth().then((auth) => {
        const localAuth = localStorage.getItem('auth')
        if (auth && auth.length && !localAuth) {
          localStorage.setItem('auth', auth)
          localStorage.setItem('auth2', 'liangyihui')
        }
      })*/
    },
    created: async function () {
      /**  微信开发工具硬编码用户openid调试用
            let openid = "oSMf3vkrJX33vq2KwlBum_q6Ykhk";
            let unionid = "o-t2buOAGIX6-Oo-5n5q33YyuoEs";
            let nickname = "Monster";
            let headimgurl = "http://bosdev.liangyihui.net/temp/1602664375.jpg";
            localStorage.setItem('openid', openid);
            localStorage.setItem('unionid', unionid);
            localStorage.setItem('nickname', nickname);
            localStorage.setItem('headimgurl', headimgurl);
            window.openid = openid;
            window.unionid = unionid;
            window.nickname = nickname;
            window.headimgurl = headimgurl;
            */
      // if(!is_app()){
      //     if(this.$route.query.userCredentials){
      //         let userCredentials= Base64.decode(this.$route.query.userCredentials)
      //         if(userCredentials){
      //           let auth1 = userCredentials.split("&")[0]
      //           let auth2 = userCredentials.split("&")[1]
      //           head.auth = auth1
      //           head.auth2 = auth2
      //           localStorage.setItem("auth",auth1)
      //           localStorage.setItem("auth2",auth2)
      //           if(this.$route.name == 'jurisdictionInfo'){
      //             globalstore.dispatch('getUserInfoPromise').then(res=>{
      //                 globalstore.dispatch('syncAuthInfo');
      //             })
      //           }
      //         }
      //     }
      // }
      var that = this

      /*
      let auth = await this.$tryGetAuth()
      console.log('created---------------tryGetAuth--auth:',auth)
      if (auth && auth.length) {
        const localAuth = localStorage.getItem('auth')
        if(!localAuth) {
          localStorage.setItem('auth', auth)
          localStorage.setItem('auth2', 'liangyihui')
          // window.location.reload()
          // return
        }
      }
      */

      isWxMiniProgram().then((res) => {
        this.isinminiprogram = res
      })

      //校验当前是否被iframe嵌套
      if (self != top) {
        this.notIframe = false
      }
      // if(process.env.NODE_ENV != 'production') {
      // 	head.auth = "JQgm3Y5jNQGYLusD857jbSlIy08T2wXvjgjZBz4A7tXnc4wgi5kbIbHS1WjKNXL2"
      // 	console.log('hare code auth')
      // }
      if (window.head.auth) {
        this.getrongyuntoken()
      }

      //$.alert(h5_version);
      //console.log(h5_version);
      eventHub.$on('prefectUserInfoShow', async function (data) {
        // 分期结果当天累计3次
        that.$nextTick(async () => {
          let state = await getTNMDetailInfoCompleteState()
          if (state) {
            that.prefectType = 0
            that.belong_page = '肿瘤分期详情页'
            that.page_source = 'tools_tnm_detail'
            that.prefectShow = true
            that.prefectNum++
          }
        })
      })

      eventHub.$on('magiclink', function (data) {
        // 暂时注销magiclink方式
        // let interval = setInterval(() => {
        //     let btns = document.querySelectorAll('.btnOpenApp')
        //     if (btns.length) {
        //         let newIdUrl = data.id || ''
        //         if (newType == 'web') {
        //             newIdUrl = data.url
        //         }
        //         let newType = ''
        //         if (data.type == 'doc'
        //          || data.type == 'live'
        //          || data.type == 'subject'
        //          || data.type == 'column'
        //          || data.type == 'question'
        //          || data.type == 'answer'
        //          || data.type == 'web'
        //          || (data.type == 'PPTDetail' && that.$route.name != 'live')) {
        //             newType = data.type
        //         }
        //         let newType = ''
        //         if (data.type == 'doc'
        //          || data.type == 'live'
        //          || data.type == 'subject'
        //          || data.type == 'column'
        //          || data.type == 'question'
        //          || data.type == 'answer'
        //          || data.type == 'web'
        //          || (data.type == 'PPTDetail' && that.$route.name != 'live')) {
        //             newType = data.type
        //         }
        //         for (let j = 0; j < options.length; ++j) {
        //             let opt = options[j] || {}
        //             opt.button.onclick = function() {
        //                 goapp(opt.type, opt.idUrl)
        //             }
        //         }
        //     }
        // }, 500);
        // 原魔链方式
        // let interval = setInterval(() => {
        //     let btns = document.querySelectorAll('.btnOpenApp');
        //     if (window.JMLink && btns.length) {
        //         console.log("clearInterval(interval)");
        //         clearInterval(interval);
        //         let link = '';
        //         if (data.type == 'doc') {
        //             link = 'https://bacvcj.jgshare.cn/AAWj';
        //         }
        //         if (data.type == 'live') {
        //             link = 'https://bacvcj.jgshare.cn/AAmI';
        //         }
        //         if (data.type == 'subject') {
        //             link = 'https://bacvcj.jgshare.cn/AAms';
        //         }
        //         if (data.type == 'column') {
        //             link = 'https://bacvcj.jgshare.cn/AAmr';
        //         }
        //         if (data.type == 'question') {
        //             link = 'https://bacvcj.jgshare.cn/AAm8';
        //         }
        //         if (data.type == 'answer') {
        //             link = 'https://bacvcj.jgshare.cn/AAmu';
        //         }
        //         if (data.type == 'web') {
        //             link = 'https://bacvcj.jgshare.cn/AAmJ';
        //         }
        //         if (data.type == 'PPTDetail' && that.$route.name != 'live') {
        //             link = 'https://bacvcj.jgshare.cn/AAmv';
        //         }
        //
        //         // let btns = document.querySelectorAll('.btnOpenApp');
        //
        //         let options = new Array();
        //         for (let i = 0; i < btns.length; ++i) {
        //             if (link && link.length) {
        //                 let plhparams = {};
        //                 if (data.type == 'web') {
        //                     plhparams.url = data.url;
        //                 } else {
        //                     plhparams.docid = data.id;
        //                 }
        //                 let config = {
        //                     jmlink: link,
        //                     button: btns[i],
        //                     plhparams: plhparams
        //                 }
        //                 options.push(config);
        //             }
        //         }
        //         console.log(options)
        //             //console.log(options);
        //         if (process.env.NODE_ENV == 'production') {
        //             // new Mlink(options);
        //             if (options.length) {
        //                 new JMLink(options);
        //             }
        //         }
        //     }
        // }, 500);
        /**
          setTimeout(function() {
              //$.alert(3);
          }, 5000);*/
        /**
         options.push({
                      mlink: (data.type === 'web') ? (link + '?url=' + data.url) : (link + '?docid=' + data.id),
                      button: btns[i]
                  });*/
        /**
         options.push({
                  jmlink: (data.type === 'web') ? encodeURIComponent(link + '?url=' + data.url) : encodeURIComponent(link + '?docid=' + data.id),
                  button: btns[i]
                });*/
      })

      setTimeout(function () {
        that.count()
        //  that.userinfo2()
      }, 250)
      this.checkLogin()
      // initTimListener()

      // _vds.push(['enableHT', true])
      // console.log('this.$route=>', this.$route);
      TimeMe.initialize({
        currentPageName: this.$route.path, // current page
      })
      function intfun() {
        let timeSpentReport = TimeMe.getTimeOnAllPagesInSeconds()
        // console.log('timeSpentReport=>', timeSpentReport);
        // console.log('上报数据后重新开始计时');
        for (let i = 0; i < timeSpentReport.length; i++) {
          let rp = timeSpentReport[i]
          let pageName = rp.pageName
          let docid = 0
          if (pageName.indexOf('/doc/') === 0) {
            docid = parseInt(pageName.replace('/doc/', ''))
          }
          if (pageName.indexOf('/live/') === 0) {
            docid = parseInt(pageName.replace('/live/', ''))
          }
          if (docid > 0) {
            let timeOnPage = Math.round(rp.timeOnPage) > 9 ? 9 : Math.round(rp.timeOnPage)
            let doctimeopt = {
              docid: docid,
              usagetime: timeOnPage,
              reqtime: Math.round(Date.now() / 1000),
            }
            that.count(doctimeopt)
          }
        }
        // 上报数据后重新开始计时
        TimeMe.resetAllRecordedPageTimes()
        TimeMe.stopTimer()
        TimeMe.setCurrentPageName(that.$route.path)
        TimeMe.startTimer()
      }
      let obj = {}
      obj.interval = setInterval(intfun, 9000)
      // Executes the first 5 times a user leaves the page
      TimeMe.callWhenUserLeaves(function () {
        // console.log("The user is not currently viewing the page!");
        clearInterval(obj.interval)
      }, 100)
      // Executes every time a user returns
      TimeMe.callWhenUserReturns(function () {
        // console.log("The user has come back!");
        obj.interval = setInterval(intfun, 9000)
        if (that.$route.path.indexOf('/doc/') === 0 || that.$route.path.indexOf('/live/') === 0) {
          that.randomdoctime(that.$route.path)
        }
      })
      if (this.$route.path.indexOf('/doc/') === 0 || this.$route.path.indexOf('/live/') === 0) {
        this.randomdoctime(this.$route.path)
      }

      if (window.ISWX || window.ISPC || (window.ISMOBILE && !window.ISAPP && !window.ISWXMINI)) {
        const apiurl = Global_AliJson_path + 'doctor_tools_loginConfig'
        this.$axios.get(apiurl).then((res) => {
          this.drugsLoginConfig = res.data || {}
        })
      }

      // 初始化AB测试配置
      await getPrefectToastConfig()
      
      // 获取用户的AB测试方案
      this.userPlan = await getUserPlan()
      console.log('userPlan ----- ', this.userPlan)
    },
    computed: {
      systemType: function () {
        if (browser.versions.android) {
          return 'android'
        } else {
          return 'ios'
        }
      },
      platform: function () {
        if (is_app()) {
          return 'app'
        } else {
          return 'wx'
        }
      },
    },
    components: {
      lyhHeader,
      SideBar,
      GoTop,
      Loading,
      TaskCountDown,
      MiniprogramToast,
      ToolsPrefectToast,
    },
    watch: {
      async $route(to, from) {
        console.log('to == ', to)
        //路由切换前清空上个路由的自定义PageLeave事件中包含的属性
        Object.keys(window.page_leave_custom_props).forEach((key) => {
          delete window.page_leave_custom_props[key]
        })

        // 路由切换前初始化是否发送pageLeave事件 默认发送
        // webViewInit， imagePreview 默认不发送
        // doc, live, subject, column 根据是否有权限访问页面动态配置
        window.pageLeaveIsCollect = true
        if (to.path.indexOf('/doc/') === 0 || to.path.indexOf('/live/') === 0) {
          this.randomdoctime(to.path)
        }
        /*
        if (window.ISWXMINI && location.href) {
          let sensorDistinctId = 'sensorDistinctId'
          let miniProgramDistinctId = getSearchParams(location.href, sensorDistinctId)
          if (miniProgramDistinctId && !localStorage.getItem('auth') && !localStorage.getItem('hasSetSensorDistinctId')) {
            //小程序中加载h5的话，未登录情况下，需要将小程序的distinctid设置给h5（一般都是小程序的openid），方便小程序和h5打通
            sensors.identify(miniProgramDistinctId, true)
            localStorage.setItem('hasSetSensorDistinctId', 1)
            // console.log("当前链接是1-----", location.href)
            location.replace(deleteUrlQuerys(location.href, [sensorDistinctId])) //重新加载url,防止url被分享，导致sensorDistinctId串给其他用户
            return
          }
        }
        */

        // console.log('to', to);
        // console.log('from', from);
        TimeMe.stopTimer()
        TimeMe.setCurrentPageName(to.path)
        TimeMe.startTimer()

        var that = this
        setTimeout(function () {
          that.count()
        }, 250)

        if (this.platform != 'app') {
          const toDepth = to.path.split('/').length
          const fromDepth = from.path.split('/').length
          this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        }

        
        if (to.meta && to.meta.isToolsPage) {
          let state = false;
          if (window.head.auth) {
            state = await this.prefectUserInfoToast(to, from) 
          }
          
          if (!state) {
            this.miniprogramGuide(to)
            this.drugsLoginConfigFun(to, from)
          }
        }
      },
    },
    methods: {
      randomdoctime(path) {
        let that = this
        let docid = 0
        if (path.indexOf('/doc/') === 0) {
          docid = parseInt(path.replace('/doc/', ''))
        }
        if (path.indexOf('/live/') === 0) {
          docid = parseInt(path.replace('/live/', ''))
        }
        if (docid > 0) {
          let timeOnPage = Math.floor(Math.random() * 8) + 1 // 1-8
          let doctimeopt = {
            docid: docid,
            usagetime: timeOnPage,
            reqtime: Math.round(Date.now() / 1000),
          }
          that.count(doctimeopt)
        }
      },
      async getrongyuntoken() {
        //if(!window.liveuserinfo) {

        let userId = sessionStorage.getItem('userId')
        userId = parseInt(userId)
        if (!userId || userId <= 0) {
          let apiurl = Global_apiserver + '/api/user/v3/exChangeAuthUid'
          let postData = { head }
          let { data } = await this.$axios.post(apiurl, postData)
          if (data && data.uid) {
            userId = data.uid
            if (userId && userId > 0) {
              sessionStorage.setItem('userId', userId)
            }
          }
        }
        // let apiurl = Global_cdn_api + `api/rongyun/gettoken/2/${userId}`
        // let { data } = await this.$axios.get(apiurl)
        // if (data.responseStatus.ack == 0) {
        //     let liveuser = data
        //     delete liveuser.responseStatus
        //     delete liveuser.code
        //     window.liveuser = liveuser
        // }

        // let that = this
        // const apiurl = Global_apiserver + 'api/rongyun/gettoken';
        // const postData = {
        //     head,
        //     actionType: 2
        // }
        // this.$axios.post(apiurl, postData).then(res => {
        //         if (res.body.responseStatus.ack == 0) {
        //             //appKey rongyunUuid token userId userName userPortraitUrl
        //             let liveuser = res.body
        //             delete liveuser.responseStatus
        //             delete liveuser.code
        //             window.liveuser = liveuser
        //                 //console.log(liveuser)
        //         } else {

        //         }
        //     }, err => {
        //         //console.log(err)
        //     })
        //}
      },
      getWxMiniAuth() {
        // 临时解决——AUTH与LYH_JSLOGIN_AUTH_KEY不同步
        const auth = localStorage.getItem('LYH_JSLOGIN_AUTH_KEY')
        if (auth && auth.length) {
          localStorage.setItem('auth', auth)
          localStorage.setItem('auth2', 'liangyihui')
          this.getAuthFromLocal()
        } else {
          this.getAuthFromLocal()
        }
      },
      getAuthFromLocal() {
        //有调用getuserINfo
        // console.log("获取auth进行silencelogin")
        const auth = localStorage.getItem('auth')
        const auth2 = localStorage.getItem('auth2')
        if (auth) {
          // 静默登录
          //从本地auth取出保存到vuex
          /*
          this.$store.dispatch('saveUser', {
            auth,
            auth2,
          })
*/

          //刷新auth
          this.silencelogin(auth, auth2)
          //  提交action
        } else {
          //本地存储没有值 不做
          // this.$router.push({ name: 'LoginCommon'})
          // this.$router.push({ name: 'Login'})
          // if(!is_app() && !is_weixin() && !IsPC()){
          //     this.$router.replace({name:'BrowserLogin'})
          // }
        }
      },
      checkLogin() {
        // console.log(this.$route.path)
        //debugger

        //设置auth 测试
        // this.$store.dispatch('saveUser', {
        //     auth:"RF2YOIPuZ38Vfjx16ly9VtDOEPBY7RjpwEs0vlJ051U=",
        //     auth2:"UeHT8L332HgjetUmpOfX+g=="}
        //   )

        // console.log(955555555559595)

        //可能是重定向过来的页面
        if (this.platform == 'app') {
          return
        }

        //无需登录过滤 开始
        let rpath = this.$route.path
        let rname = this.$route.name

        if (rname == 'Vote') {
          return
        }
        //alert(rpath)
        if (rpath.indexOf('/csco') >= 0) {
          if (!(rpath == '/csco/company/1')) {
            return
          }
        }
        if (rpath.indexOf('/adddoctor') >= 0) {
          return
        }
        //无需登录过滤 结束

        if (!window.unionid) {
          // 不是重定向来的
          //unionid == ""
          /*
          ps: 这段不需要了，已经通过setNotAppInit()中的tryGetAuth处理了的
          if (window.ISWXMINI) {
            this.getWxMiniAuth()
          } else {
          */
          this.getAuthFromLocal()
          /*
          }
          */
          return
        }

        // 以下是=====重定向过来=====的处理代码

        if (localStorage.getItem('auth')) {
          head.auth = localStorage.getItem('auth')
          head.auth2 = localStorage.getItem('auth2')
        }

        localStorage.setItem('openid', openid)
        localStorage.setItem('unionid', unionid)
        localStorage.setItem('nickname', nickname)
        localStorage.setItem('headimgurl', headimgurl)

        //微信返回unionid
        const apiurl = api.wxLogin.apiurl
        const postData = api.wxLogin.postData
        postData.thirdPartAuth = openid
        postData.thirdPartAuth2 = unionid
        postData.type = is_app() ? 1 : 7 //本方法其实只有微站使用的，固定为7的

        var that = this
        communicate(apiurl, postData, (response) => {
          //console.log(response)
          var data = response.body
          //console.log(rname)
          if (data.ifAuthorized == 1 && data.auth) {
            localStorage.setItem('JumpToAnswerLogin', false) //微信中，答题相关的内容要用到

            //1已绑定 设置auth
            //微信登录没有name和userId
            const { auth, auth2 } = data

            const user = {
              auth,
              auth2,
            }

            head.auth = auth
            head.auth2 = auth2

            //设置auth
            that.$store.dispatch('saveUser', user)

            //获得用户信息
            //that.getUserInfo();
          } else {
            if (
              rname == 'CaseHomepage' ||
              rname == 'ShareCaseChallenge' ||
              rname == 'SelectCase' ||
              rname == 'AZHomepage' ||
              rname == 'AZShareCaseChallenge' ||
              rname == 'AZSelectCase' ||
              rname == 'GKQuestion' ||
              rname == 'AnswerQDailyAnswerPage' ||
              rname == 'AnswerQSpecialReslutPage' ||
              rname == 'AnswerQLogin' ||
              rname == 'AddDoctor' ||
              rname == 'BRHomepage' ||
              rname == 'BRShareCaseChallenge' ||
              rname == 'BRSelectCase'
            ) {
              if (rname == 'AnswerQDailyAnswerPage' || rname == 'AnswerQSpecialReslutPage') {
                //在微信中
                //①打开每周答题分享结果时，会走本分支；
                //②打开专项答题的分享结果时，会走本分支；
                //答题页，若是微信对应的手机号 未在 肿瘤医生平台 中注册过，则在微信授权成功后，让用户进行手机号注册

                location.href = '#/AnswerQLogin'
              }
            } else {
              // 去输入手机号 密码 注册页面
              // this.$router.push({name: 'Login'});
              if (localStorage.getItem('academic_ambassador_giftId')) {
                location.href = '#/identify/info'
                localStorage.removeItem('academic_ambassador_giftId')
              } else {
                location.href = '#/login'
              }
            }
          }
        })
      },
      getUserInfo() {
        var apiurl = api.getuserinfo.apiurl
        var postData = api.getuserinfo.postData
        postData.head.auth = this.$store.state.user.auth
        communicate(apiurl, postData, (res) => {
          const data = res.data
          //console.log('getUserInfo()')
          // console.log(data)
          // console.log(res)
        })
      },
      //统计时长
      userinfo2() {
        //routerList需要统计时长的路由集合
        let routerList = [
          {
            resourceId: 'id', //路由参数,例如docid/id
            resourceType: 'article', //页面访问类型
            routerType: 'params', //路由挑战方式：params/query
            name: 'doc', //页面路由name
          },
          {
            resourceId: 'id',
            resourceType: 'article',
            routerType: 'params',
            name: 'live',
          },
        ]
        //域名
        let url = document.location.host
        console.log(head.auth)
        console.log(routerList)
        console.log('userinfo2')
        let laiyuan = is_app() ? 'app' : 'wx'

        if (browser.versions.android) {
          laiyuan = laiyuan + '_Android'
        }
        if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
          laiyuan = laiyuan + '_iOS'
        }
        console.log(laiyuan)
        if (head.auth) {
          const userinfoobjstr = JSON.parse(sessionStorage.getItem('userinfoobjstr')) || ''
          console.log(userinfoobjstr)
          if (userinfoobjstr && userinfoobjstr.userid) {
            let userId = userinfoobjstr.userid
            initWs(
              routerList,
              'wss://ws.liangyihui.net:8024',
              10000,
              {
                userId: userId,
                evn: url == 'doctor.liangyihui.net' ? 'prod' : 'dev',
                userType: 'doctorUser',
                platformTitle: 'doctor',
                laiyuan: laiyuan,
              },
              router
            )
          } else {
            const apiurl = Global_apiserver + '/api/user/getuserinfo'
            const postData = {
              head: head,
            }
            this.$axios.post(apiurl, postData).then(
              (response) => {
                var res = response.data
                if (res && res.responseStatus && res.responseStatus.ack) {
                  if (res.responseStatus.ack != 0) {
                    //auth 过期 或 不合法，返回空
                  } else {
                    //这么多ifelse分支，终于走到 正经地方了

                    if (res.basic) {
                      let userId = res.basic.userId
                      console.log(userId)
                      initWs(
                        routerList,
                        'wss://ws.liangyihui.net:8024',
                        10000,
                        {
                          userId: userId,
                          evn: url == 'doctor.liangyihui.net' ? 'prod' : 'dev',
                          userType: 'doctorUser',
                          platformTitle: 'doctor',
                          laiyuan: laiyuan,
                        },
                        router
                      )
                    }
                  }
                }
              },
              (err) => {}
            )
          }
        } else {
          let LYHUUID = localStorage.getItem('LYHUUID') || ''
          initWs(
            routerList,
            'wss://ws.liangyihui.net:8024',
            10000,
            {
              userId: LYHUUID,
              evn: url == 'doctor.liangyihui.net' ? 'prod' : 'dev',
              userType: 'doctorVistor',
              platformTitle: 'doctor',
              laiyuan: laiyuan,
            },
            router
          )
        }
      },
      count(doctimeopt) {
        // 时长埋点用到doctimeopt
        var that = this
        var vurl = this.$route.fullPath
        //console.log('path:' + vurl)
        // 因遇到百度统计js加载失败，移除百度统计
        // if (!doctimeopt) {
        //     _hmt.push(['_trackPageview', vurl]);
        // }

        var qd = this.$route.query.qd
        if (!qd) {
          qd = sessionStorage.getItem('for_count_qd')
        } else {
          sessionStorage.setItem('for_count_qd', qd)
        }

        //alert(qd)

        // 1. 先从本地存储中 取cid

        var userinfo = {
          mobile: '',
          gender: '',
          level: 0,
          type: 0,
          hospital: '',
          department: '',
          jobtitle: '',
        }

        //getUUID
        function getUUID() {
          var uuidkey = 'LYHUUID'

          var uuid = localStorage.getItem(uuidkey)

          if (!uuid) {
            if (is_app()) {
              nativefun('getHead1', {}, function (responseData) {
                var obj = JSON.parse(responseData)
                uuid = obj.cid
                if (!uuid) {
                  uuid = new GUID().newGUID()
                }
                localStorage.setItem(uuidkey, uuid)
                g.next(uuid)
              })
            } else {
              uuid = new GUID().newGUID()
              localStorage.setItem(uuidkey, uuid)
              setTimeout(function () {
                g.next(uuid)
              }, 0)
            }
          } else {
            setTimeout(function () {
              g.next(uuid)
            }, 0)
          }
        }

        function getuserinfo() {
          //首先判断有没有登录，如果没有登录 用户信息为空
          //console.log('12345');

          let savekey = 'userinfoobjstr'

          if (head.auth) {
            //如果已经登录 先从本地存储中获取用户信息，标志字段是 mobile ，mobile有就算userinfo 已经存本地
            let userInfostr = sessionStorage.getItem(savekey) || localStorage.getItem(savekey)
            let gobaowenget = false
            let userInfoObj
            if (userInfostr) {
              userInfoObj = JSON.parse(userInfostr)
              if (userInfoObj && userInfoObj.mobile) {
                //本地存储保存了用户信息
                setTimeout(function () {
                  sessionStorage.setItem(savekey, userInfostr)
                  g.next(userInfoObj)
                }, 0)
              } else {
                //本地存储保存的用户信息不合法
                gobaowenget = true
              }
            } else {
              //本地存储没有保存用户信息
              gobaowenget = true
            }

            if (gobaowenget) {
              //请求报文 从服务器拉取用户信息
              const apiurl = api.getUserInfoDiff.apiurl
              const postData = {
                head: head,
                pro: '1',
              }
              that.$axios.post(apiurl, postData).then(
                (response) => {
                  var res = response.data
                  if (res.responseStatus.ack != 0) {
                    //auth 过期 或 不合法，返回空
                    g.next(userinfo)
                  } else {
                    //这么多ifelse分支，终于走到 正经地方了

                    if (res.basic) {
                      userinfo = {
                        userid: res.basic.userId,
                        mobile: res.basic.mobile,
                        gender: res.basic.gender,
                        level: res.basic.level,
                        type: res.basic.type,
                        hospital: '',
                        department: '',
                        jobtitle: '',
                      }
                    }
                    if (res.professional && res.professional.companies && res.professional.companies.length > 0) {
                      let item = res.professional.companies[0]
                      userinfo.hospital = item.companyName
                      userinfo.department = item.deptName
                      userinfo.jobtitle = item.deptTitle
                    }
                    if (userinfo.mobile) {
                      //有手机号就算取到了有效用户信息
                      userInfostr = JSON.stringify(userinfo)
                      sessionStorage.setItem(savekey, userInfostr)
                      localStorage.setItem(savekey, userInfostr)
                    }
                    g.next(userinfo)
                  }
                },
                (err) => {
                  //报文取错误，返回空 userinfo
                  console.log(err)
                  g.next(userinfo)
                }
              )
            }
          } else {
            //未登录 直接返回空，userinfo 为上面这个子函数外定义
            setTimeout(function () {
              g.next(userinfo)
            }, 0)
          }
        }

        function* doit() {
          let uuid = yield getUUID()
          let laiyuan = is_app() ? 'app' : 'wx'
          // openid_tmp重新赋值
          window.openid_tmp = uuid

          if (browser.versions.android) {
            laiyuan = laiyuan + '_Android'
          }
          if (browser.versions.iPhone || browser.versions.iPad || browser.versions.ios) {
            laiyuan = laiyuan + '_iOS'
          }
          var funname = ''

          if (vurl == '/') {
            funname = 'homepage'
          } else {
            funname = vurl
          }
          // console.log('url',funname);

          let userinfo = yield getuserinfo()
          let aliyunmd = {
            laiyuan: laiyuan,
            uuid: uuid,
            funname: funname,
            mobile: userinfo.mobile,
            gender: userinfo.gender,
            level: userinfo.level,
            type: userinfo.type,
            hospital: userinfo.hospital,
            department: userinfo.department,
            jobtitle: userinfo.jobtitle,
            userid: userinfo.userid,
            env: Global_apiserver.indexOf('demohdtapi.liangyihui.net') > 0 ? 'dev' : 'prod',
          }
          if (qd) {
            aliyunmd.qd = qd
          }
          if (doctimeopt) {
            aliyunmd.docid = doctimeopt.docid
            aliyunmd.reqtime = doctimeopt.reqtime
            aliyunmd.usagetime = doctimeopt.usagetime
            aliyunmd.guid = new GUID().newGUID()
          }
          aliyunlog(aliyunmd, doctimeopt)
        }

        var g = doit()
        g.next()
      },
      silencelogin() {
        /*
        //sensors.logout()
        const apiurl = api.silencelogin.apiurl
        const postData = api.silencelogin.postData

        console.log('走到silencelogin-----------------')
        communicate(apiurl, postData, (res) => {
          //调用getuserInfo
          if (res && res.body && res.body.responseStatus) {
*/

        const ack = silenceLoginData.body.responseStatus.ack
        if (ack == 0) {
          //重置auth
          const auth = localStorage.getItem('auth')
          const auth2 = localStorage.getItem('auth2')
          /*
              const { auth, auth2, name, userId } = res.body

              this.$store.dispatch('saveUser', {
                auth,
                auth2,
              })

              sensors.logout()
              sensors.login(res.body.userId) //静默登录成功过后调用神策login方法
              Sentry.setUser({ id: res.body.userId })
              this.getDoctorTag()
              */
          setTimeout(() => {
            document.getElementById('lyh-login-iframe').contentWindow.postMessage('LYH_AUTH:' + auth, '*')
          }, 3000)
        } else if (ack == 1) {
          //auth过期 是否需要重新登录
          // var that = this;
          // setTimeout( function () {
          //   that.$router.push({ name: 'Login'})
          //
          // },1000)
          /*
              localStorage.removeItem('auth')
              localStorage.removeItem('auth2')
              window.location.reload()
              */
        }
        /*
          }
        })
        */
      },
      commonPost(callback) {
        if (is_app()) {
          if (!auth1) {
            nativefun('getAuth')
          } else {
            callback.call(null)
          }
        } else {
          goapp(1)
        }
      },
      async apply(id, subscribe, callback) {
        //收藏专栏
        //alert(2);
        var a
        if (subscribe) {
          a = 1
        } else {
          a = 0
        }
        if (is_app()) {
          if (!auth1) {
            // 埋点数据构造
            var postmdjson = mdjson.buriedItems[0]
            postmdjson.actionType = 3
            postmdjson.contentType = 5
            postmdjson.targetObject = 'columnistRSS'
            postmdjson.params[0] = id
            postmdjson.currentTime = gettimestamp()

            //$.alert(JSON.stringify(postmdjson));
            nativefun('buriedBaster', {
              param: postmdjson,
            })

            nativefun('getAuth')
          } else {
            var postData = {
              Columnists: [
                {
                  ID: id,
                  isSubscribe: a,
                },
              ],
              head,
            }
            //alert(JSON.stringify(postData));
            var apiurl = Global_apiserver + 'api/pub/setusercolumnist'
            this.$axios.post(apiurl, postData).then((res) => {
              if (res && res.body && res.body.responseStatus) {
                callback(res.body)
                nativefun(
                  'subscribe',
                  {
                    param: res.body.responseStatus,
                  },
                  function (responseData) {}
                )

                if (res.body.responseStatus.ack == 0 && a == 1) {
                  this.finishTaskByConditionCode('f_c', id)
                }
              }
              // if (
              //   res.body.responseStatus &&
              //   res.body.responseStatus.extraMissionInfo &&
              //   res.body.responseStatus.extraMissionInfo.doneMissions &&
              //   res.body.responseStatus.extraMissionInfo.doneMissions.length
              // ) {
              //   if (is_app()) {
              //     setTimeout(() => {
              //       nativefun('getDoneMission', { param: res.body.responseStatus.extraMissionInfo }, function (responseData) {})
              //     }, 1500)
              //   }
              // }

              //console.log(JSON.stringify(response))

              //this.value.isSubscribe = subscribe;
              //alert(JSON.stringify(response));
            })
          }
        } else {
          if (!window.head.auth) {
            // const auth = await this.$forceGetAuth()
            // head.auth = auth
            await doLoginCompatMiniPro()
          } else {
            var postData = {
              Columnists: [
                {
                  ID: id,
                  isSubscribe: a,
                },
              ],
              head,
            }
            var apiurl = Global_apiserver + 'api/pub/setusercolumnist'
            this.$axios.post(apiurl, postData).then((res) => {
              if (res && res.body && res.body.responseStatus) {
                callback(res.body)
                nativefun(
                  'subscribe',
                  {
                    param: res.body.responseStatus,
                  },
                  function (responseData) {}
                )
                if (res.body.responseStatus.ack == 0 && a == 1) {
                  this.finishTaskByConditionCode('f_c', id)
                }
              }
              // if (
              //   res.body.responseStatus &&
              //   res.body.responseStatus.extraMissionInfo &&
              //   res.body.responseStatus.extraMissionInfo.doneMissions &&
              //   res.body.responseStatus.extraMissionInfo.doneMissions.length
              // ) {
              //   if (is_app()) {
              //     setTimeout(() => {
              //       nativefun('getDoneMission', { param: res.body.responseStatus.extraMissionInfo }, function (responseData) {})
              //     }, 1500)
              //   }
              // }
              //console.log(JSON.stringify(response))

              //this.value.isSubscribe = subscribe;
              //alert(JSON.stringify(response));
            })
          }
          // goapp(1);
        }
      },
      starSubject(id, action, type, callback) {
        //关注和收藏专题 type = 0 关注 type = 1 收藏
        if (is_app()) {
          if (!auth1) {
            // 埋点数据构造
            var postmdjson = mdjson.buriedItems[0]
            postmdjson.actionType = 3
            postmdjson.contentType = 5
            if (type == 0) {
              postmdjson.targetObject = 'eventFollow'
            } else {
              postmdjson.targetObject = 'eventCollect'
            }
            postmdjson.params[0] = id
            postmdjson.currentTime = gettimestamp()

            //$.alert(JSON.stringify(postmdjson));
            nativefun('buriedBaster', {
              param: postmdjson,
            })

            nativefun('getAuth')
          } else {
            var actionType
            if (type == 0) {
              if (action == 0) {
                //关注会议
                actionType = 4
              } else {
                //取消关注会议
                actionType = 5
              }
            } else {
              if (action == 0) {
                //收藏
                //console.log('eventId: ' + id + '  ,收藏');
                actionType = 6
              } else {
                //取消收藏
                //console.log('eventId: ' + id + '  ,取消收藏');
                actionType = 7
              }
            }

            var apiurl = Global_apiserver + '/api/doc/signup'

            //var mdjsonstr = JSON.stringify(mdjson);
            //var postmdjson = JSON.parse(mdjsonstr);

            //postmdjson

            var postData = {
              head,
              eventId: id,
              actionType: actionType,
            }

            this.$axios.post(apiurl, postData).then(
              (res) => {
                //console.log(JSON.stringify(response))
                if (res && res.body && res.body.responseStatus) {
                  nativefun(
                    'subscribe',
                    {
                      param: res.body.responseStatus,
                    },
                    function (responseData) {}
                  )
                  callback()
                }
              },
              function (response) {}
            )
          }
        } else {
          goapp(1)
        }
      },
      versionUpdateTips(targetVer, msg) {
        // 判断版本更新提示，APP外head.cver默认3.5.3，APP内通过JSBridge获取app版本号比较 -1 当前版本比目标版本旧 ; 0 与目标版本相同 ; 1 大于目标版本 (一般在当前页面弃用时做提示用)
        var vpthat = this
        if (compareVer(head.cver, targetVer) === -1) {
          MessageBox.alert(msg ? msg : '您的当前版本过旧，请更新APP以获取最佳体验!').then((action) => {
            if (is_app()) {
              if (browser.versions.android) {
                window.location.href = 'lyh://native.liangyihui.net/browser?url=https://doctor.liangyihui.net/doctor/app.html'
              } else {
                window.location.href = 'lyh://native.liangyihui.net/browser?url=https://itunes.apple.com/cn/app/id1034265664'
              }
            } else {
              window.location.href = 'https://doctor.liangyihui.net/doctor/app.html'
            }
            vpthat.versionUpdateTips(targetVer, msg)
          })
        }
      },
      versionUpdateTipsInApp(targetVer, msg, autoHide) {
        // 只在APP内版本更新提示 (一般当前H5页面与新版本APP有新的交互逻辑，老版本APP无法满足当前页面的交互时调用)
        var vpthat = this
        if (compareVer(head.cver, targetVer) === -1 && is_app()) {
          MessageBox.alert(msg ? msg : '您的当前版本过旧，请更新APP以获取最佳体验!').then((action) => {
            if (browser.versions.android) {
              window.location.href = 'lyh://native.liangyihui.net/browser?url=https://doctor.liangyihui.net/doctor/app.html'
            } else {
              window.location.href = 'lyh://native.liangyihui.net/browser?url=https://itunes.apple.com/cn/app/id1034265664'
            }
            if (autoHide) {
            } else {
              vpthat.versionUpdateTipsInApp(targetVer, msg)
            }
          })
        }
      },

      versionUpdateTipsOnceInApp(targetVer, msg) {
        // 只在APP内版本更新提示 (一般当前H5页面与新版本APP有新的交互逻辑，老版本APP无法满足当前页面的交互时调用)----只会弹出一次
        if (compareVer(head.cver, targetVer) === -1 && is_app()) {
          this.showUpdateDialog(msg)
        }
      },

      showUpdateDialog(msg) {
        MessageBox.alert(msg ? msg : '您的当前版本过旧，请更新APP以获取最佳体验!').then((action) => {
          if (browser.versions.android) {
            window.location.href = 'lyh://native.liangyihui.net/browser?url=https://doctor.liangyihui.net/doctor/app.html'
          } else {
            window.location.href = 'lyh://native.liangyihui.net/browser?url=https://itunes.apple.com/cn/app/id1034265664'
          }
        })
      },

      async applyConsultation(remoteConsultationUrl) {
        if (!window.head.auth) {
          const auth = await this.$forceGetAuth()
          head.auth = auth
          return
        }
        let acthat = this
        // 先获取身份判断是否已通过认证
        let userInfoData = {
          head,
        }
        let userInfoUrl = Global_apiserver + 'api/user/v3/getUserInfoBasic'
        this.$axios.post(userInfoUrl, userInfoData).then(
          (response) => {
            if (response.ok) {
              let userInfo = response.data
              let userLevel = userInfo.userBasicInfo.level
              if (userLevel === 1 || userLevel === 3) {
                // 1.未认证 3.认证被拒
                if (is_app()) {
                  nativefun('checkUserRightsForCertifiedOptions')
                } else {
                  Toast('请先登录良医汇APP进行认证，认证通过后方可进行操作')
                }
              } else if (userLevel === 4) {
                // 认证审核中
                Toast('您的认证正在审核中，请稍后操作')
              } else if (userLevel === 2) {
                // 已认证，可以进行申请会诊操作
                if (userInfo.userBasicInfo.type !== 1) {
                  Toast('会诊服务仅针对已认证的医生用户开放！')
                  return
                }
                if (remoteConsultationUrl && remoteConsultationUrl.length) {
                  if (is_app()) {
                    // nativefun('goToCommonWebPage', {param: {url:remoteConsultationUrl, needNotShowShareBtn: 1}});
                    nativefun('goToConsultationEdit', { param: { url: remoteConsultationUrl, needNotShowShareBtn: 1 } })
                  } else {
                    window.location.href = remoteConsultationUrl
                  }
                } else {
                  // Toast('该医生/团队暂未开通会诊服务');
                  Toast('您暂时无法向该医生/团队申请会诊')
                }
              } else {
                Toast('抱歉,您不符合申请会诊条件,无法申请会诊!')
              }
            } else {
              Toast('抱歉,暂时无法申请会诊,请稍后再试!')
            }
          },
          (response) => {
            Toast('抱歉,暂时无法申请会诊,请稍后再试!')
          }
        )
      },
      maidianappwxminiapp(groupname, funname) {
        // 埋点app wx miniapp
        var mdthat = this
        if (is_app()) {
          mdthat.maidian(groupname + '_app', funname)
        } else {
          isWxMiniProgram().then(function (res) {
            if (res) {
              mdthat.maidian(groupname + '_mapp', funname)
            } else {
              mdthat.maidian(groupname + '_wx', funname)
            }
          })
        }
      },
      maidianappwx(groupname, funname) {
        // 只埋点app wx，miniapp上单独在miniapp上埋点
        var mdtt = this
        if (is_app()) {
          mdtt.maidian(groupname + '_app', funname)
        } else {
          isWxMiniProgram().then(function (res) {
            if (res) {
              // mdtt.maidian(groupname + '_mapp', funname);
            } else {
              mdtt.maidian(groupname + '_wx', funname)
            }
          })
        }
      },
      maidian(groupname, funname) {
        var tt = this
        if (is_app()) {
          setTimeout(function () {
            nativefun('getHead1', {}, function (responseData) {
              var hd = JSON.parse(responseData)
              tt.maidianrequest(groupname, funname, hd.cid)
            })
          }, 1000)
        } else {
          tt.maidianrequest(groupname, funname, null)
        }
      },
      maidianrequest(groupname, funname, udid) {
        var pd = {
          uuid: udid,
          funname: funname ? funname : location.href,
          groupname: groupname,
        }
        var urlstr = '//web.liangyihui.net/mdtj/mdlog/md'
        this.$axios.post(urlstr, pd).then(
          (res) => {},
          (res) => {}
        )
      },
      /*
      // 获取用户tag 神策数据埋点来源
      getDoctorTag() {
        if (head.auth) {
          let postData = {
            head,
            tagGroupId: 2, //分组ID 1: 行为属性  2: 基础属性
          }
          let postUrl = Global_apiserver + 'api/tag/getDoctorTag'
          this.$axios.post(postUrl, postData).then((response) => {
            if (response.ok) {
              let res = response.body
              let tags = {}
              if (res.data && res.data.length) {
                res.data.forEach((item) => {
                  tags[item.tagCode] = item.valueDesc
                })
                tags['userId'] = res.data[0].userId
                console.log(tags, 'tag1')
              }
              var tagsKeys = Object.keys(tags)
              if (tagsKeys.length) {
                sensors.setProfile(tags)
              }
            }
          })
        }
      },
      */
      // 神策埋点自定义方法  this.$root.getSensorsTrackFunction() 全局调用
      getSensorsTrackFunction(name, obj) {
        //name 自定义名称  obj 需要存储的自定义属性
        sensors.track(name, obj)
      },
      // 引导小程序
      miniprogramGuide(to) {
        console.log('to == ', to)
        if (!window.ISAPP && !window.ISWXMINI && !window.ISPC && this.notIframe) {
          // let guideRecord = localStorage.getItem('record_miniprogram_time')
          // if (!guideRecord || guideRecord === null) {
          //   this.miniGuide = true
          // } else {
          //   guideRecord = parseInt(guideRecord, 10)
          //   let timestamp = Math.floor(new Date().getTime() / 1000)
          //   let timeDifference = timestamp - guideRecord
          //   if (timeDifference > 7200) {
          //     // 超过2小时
          //     this.miniGuide = true
          //   } else {
          //     // 少于2小时
          //     let currentDate = new Date(timestamp * 1000)
          //     let recordedDate = new Date(guideRecord * 1000)
          //     let isSameDay = currentDate.getFullYear() === recordedDate.getFullYear() && currentDate.getMonth() === recordedDate.getMonth() && currentDate.getDate() === recordedDate.getDate()
          //     if (!isSameDay) {
          //       // 不在同一天
          //       this.miniGuide = true
          //     } else {
          //       this.miniGuide = false
          //     }
          //   }
          // }

          // 页面访问次数
          let guideRecord = parseInt(localStorage.getItem('record_miniprogram_count'));
          // 页面访问记录
          let guideRecordUrlArr = localStorage.getItem('record_miniprogram_arr') ? JSON.parse(localStorage.getItem('record_miniprogram_arr')) : [];

          // 访问时间
          let guideRecordTime = localStorage.getItem('record_miniprogram_time');
          // 判断是否超时，跨天记录清除
          let overTime = false;
          if (guideRecordTime) {
            // 有时间记录
            guideRecordTime = parseInt(guideRecordTime, 10);
            let timestamp = Math.floor(new Date().getTime() / 1000);
            let recordedDate = new Date(guideRecordTime * 1000);
            let currentDate = new Date(timestamp * 1000);
            let isSameDay = currentDate.getFullYear() === recordedDate.getFullYear() && currentDate.getMonth() === recordedDate.getMonth() && currentDate.getDate() === recordedDate.getDate()
            if (!isSameDay) {
              // 不在同一天
              overTime = true;
              guideRecord = 0;
              localStorage.setItem('record_miniprogram_count', guideRecord); 
              localStorage.setItem('record_miniprogram_arr', []);
            } else {
              overTime = false;
            }
          } else {
            overTime = true;
            guideRecord = 0;
            localStorage.setItem('record_miniprogram_count', guideRecord); 
            localStorage.setItem('record_miniprogram_arr', []);
          }
          
          // console.log('guideRecord == ', guideRecord)
          if (!guideRecord || guideRecord === null || guideRecord === 0 || overTime) {
            this.miniGuide = true;
          } else {
            // 访问不同 url 时计数 +1
            // console.log('count');
            if (!guideRecordUrlArr.includes(to.fullPath)) {
              // console.log('count+1')
              guideRecord = guideRecord + 1;
              guideRecordUrlArr.push(to.fullPath);
              localStorage.setItem('record_miniprogram_arr', JSON.stringify(guideRecordUrlArr));
            }
            
            if (guideRecord === 4) {
              guideRecord = 0;
              localStorage.setItem('record_miniprogram_arr', []);
              this.miniGuide = true;
            } else {
              this.miniGuide = false;
            }
            localStorage.setItem('record_miniprogram_count', guideRecord);    
          }
        }
      },
      closeMini() {
        this.miniGuide = false
      },
      async prefectUserInfoToast(to, from) {
        let state = await getToolsInfoCompleteState(to, from);
        console.log('state:', state)
        if (state) {
          // 用户信息弹窗
          this.prefectType = 1
          this.belong_page = to.meta.infoCompleteData.belong_page || ''
          this.page_source = to.meta.infoCompleteData.page_source || ''
          this.prefectShow = true
          this.prefectNum++
          console.log('prefectNum', this.prefectNum)
          return true
        }
        return false
      },
      // 肿瘤药物相关页面登录权限逻辑
      async drugsLoginConfigFun(to, from) {
        // 患者端跳转-临床指南，ua里包含miniProgram和这两个appid的时候不弹登录弹窗
        const regex = /miniProgram\/(wx6e73d168d61048bd|wx59e8730d7d503016)/
        if (regex.test(navigator.userAgent)) {
          return
        }
        const fromUrl = from.fullPath
        const toUrl = to.fullPath
        const fromName = from.name
        const toName = to.name
        if (!this.drugsLoginConfig) {
          const apiurl = Global_AliJson_path + 'doctor_tools_loginConfig'
          const data = await this.$axios.get(apiurl)
          this.drugsLoginConfig = data.data || {}
        }
        if (this.drugsLoginConfig.viewCount) {
          if ((window.ISWX || window.ISPC || window.ISMOBILE || window.ISAPP || window.ISWXMINI) && !window.head.auth) {
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth() + 1 // 月份从0开始，需要加1
            const day = now.getDate()
            const accessTime = `${year}-${month}-${day}`
            let metadata = {
              urls: [],
              isTrigger: false,
              accessTime,
            }
            let userAccessInformation = localStorage.getItem('user_access_information') ? JSON.parse(localStorage.getItem('user_access_information')) : {}
            // 当前时间和缓存中时间相同时更新元数据
            if (userAccessInformation && userAccessInformation.accessTime == accessTime) {
              metadata = JSON.parse(JSON.stringify(userAccessInformation))
            }
            // 当日没有触发过登录时
            if (!metadata.isTrigger) {
              // if (!metadata.urls.includes(decodeURIComponent(fromUrl)) && this.drugsRouteName.includes(fromName)) {
              //   metadata.urls.push(decodeURIComponent(fromUrl))
              // }
              // if (!metadata.urls.includes(decodeURIComponent(toUrl)) && this.drugsRouteName.includes(toName)) {
              //   metadata.urls.push(decodeURIComponent(toUrl))
              // }

              if (to.meta && to.meta.isToolsPage && metadata.urls.length <= this.drugsLoginConfig.viewCount) {
                metadata.urls.push(decodeURIComponent(toUrl))
              }

              // 当前访问页面数 == 配置时触发登录组件
              if (metadata.urls.length == this.drugsLoginConfig.viewCount) {
                metadata.isTrigger = true
                const url = new URL(location.href)
                // if (!url.searchParams.get('fromlogin')) {
                // this.getTrackParams(from)
                this.getTrackParams(from, to)
                this.$root.getSensorsTrackFunction('RegisterloginHintShow', this.trackParams)
                // }

                Dialog.confirm({
                  title: '',
                  message: '登录后可访问更多内容',
                  confirmButtonText: '立即登录',
                  confirmButtonColor: '#DA1572',
                  cancelButtonText: '下次再说',
                  cancelButtonColor: '#9E9EAB',
                })
                  .then(async () => {
                    this.getSensorsTrackFunction('RegisterloginHintButtonClick', this.trackParams)
                    await doLoginCompatMiniPro({ entranceSource: this.trackParams.entrance_source, canBeSkipped: true })
                    // if (window.ISPC || (window.ISMOBILE && !window.ISAPP && !window.ISWX && !window.ISWXMINI)) {
                    //   window.location.reload()
                    // }
                    if (window.ISPC) {
                      window.location.reload()
                    }
                    // 登录成功后初始化缓存中的数据
                    metadata = {
                      urls: [],
                      isTrigger: false,
                      accessTime,
                    }
                    localStorage.setItem('user_access_information', JSON.stringify(metadata))
                  })
                  .catch(() => {
                    // on cancel
                  })
              }
              localStorage.setItem('user_access_information', JSON.stringify(metadata))
            }
          }
        }
      },
      getTrackParams(from, to) {
        const pageSource = 'registerlogin' + to.path.replace(/\//g, '_')
        let entrance_source = ''
        switch (from.name) {
          case 'doc':
            entrance_source = '文章详情页'
            break
          case 'live':
            entrance_source = '直播详情页'
            break
          case 'column':
            entrance_source = '专栏详情页'
            break
          case 'subject':
            entrance_source = '专题详情页'
            break
          default:
            entrance_source = '其他'
        }
        let login_type = ''
        switch (window.platformType) {
          case 'wx':
            login_type = '微信登录'
            break
          case 'mb':
            login_type = '浏览器登录'
            break
          case 'iOS':
            login_type = 'APP登录'
            break
          case 'Android':
            login_type = 'APP登录'
            break
          case 'pc':
            login_type = 'PC登录'
            break
          case '小程序':
            login_type = '小程序登录'
            break
          default:
            login_type = ''
        }
        this.trackParams = {
          // platform_type: window.platformType,
          page_source: pageSource,
          entrance_source: entrance_source,
          login_type: login_type,
          channel: from.query.channel || '',
        }
      },
    },
    router,
  })
}
function sensorsRegisterPage(platformType) {
  sensors.registerPage({
    user_agent: window.navigator.userAgent,
    current_url: location.href,
    referrer: document.referrer,
    platform_type: platformType,
    is_in_iframe: self != top,
  })

  // 设置全局覆盖属性
  sensors.register({
    $user_agent: window.navigator.userAgent,
  })
  // console.log(platformType)
}
// 实例化
const exp = new Exposure(sensors)
const cli = new Click(sensors)
Vue.directive('track', {
  bind(el, binding) {
    //PS：如果没有触发本监听，可以先将数据列表的数组置空，然后再进行网络请求并将获取的数据设置到数组中
    const { arg } = binding
    arg.split('|').forEach((item) => {
      // 点击
      if (item === 'click') {
        cli.add({ el })
      } else if (item === 'exposure') {
        exp.add({ el })
      }
    })
  },
})
//this.$route.params.docId
